import { Box, Container, Divider, Link, Stack, Typography } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import { useTranslation } from "react-i18next";

const YEAR = new Date().getFullYear();

export default function Footer() {
  const { t } = useTranslation("common");
  return (
    <Box
      component="footer"
      sx={{
        mt: "auto",
        borderTop: 1,
        borderColor: "divider",
        bgcolor: "background.paper",
        py: { xs: 4, md: 5 },
      }}
    >
      <Container maxWidth="lg">
        <Stack
          direction={{ xs: "column", md: "row" }}
          spacing={{ xs: 4, md: 6 }}
          justifyContent="space-between"
          alignItems={{ xs: "flex-start", md: "flex-start" }}
        >
          <Box sx={{ maxWidth: 320 }}>
            <Typography variant="h6" sx={{ fontWeight: 500, mb: 1 }}>
              {t("Footer.brand")}
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 1.5 }}>
              {t("Footer.tagline")}
            </Typography>
            <Typography variant="caption" color="text.secondary" sx={{ display: "block" }}>
              {t("Footer.productOf")}
            </Typography>
          </Box>

          <Stack
            direction={{ xs: "column", sm: "row" }}
            spacing={{ xs: 3, sm: 6 }}
            sx={{ flexGrow: 1, justifyContent: { md: "flex-end" } }}
          >
            <Stack spacing={1}>
              <Typography
                variant="overline"
                color="text.secondary"
                sx={{ fontWeight: 600, letterSpacing: "0.08em" }}
              >
                {t("Footer.product")}
              </Typography>
              <Link component={RouterLink} to="/" color="text.primary" underline="hover">
                {t("Footer.home")}
              </Link>
              <Link component={RouterLink} to="/pricing" color="text.primary" underline="hover">
                {t("Footer.pricing")}
              </Link>
              <Link
                component={RouterLink}
                to="/career-transition"
                color="text.primary"
                underline="hover"
              >
                {t("Footer.careerTransition")}
              </Link>
            </Stack>

            <Stack spacing={1}>
              <Typography
                variant="overline"
                color="text.secondary"
                sx={{ fontWeight: 600, letterSpacing: "0.08em" }}
              >
                {t("Footer.legal")}
              </Typography>
              <Link component={RouterLink} to="/terms" color="text.primary" underline="hover">
                {t("Footer.termsOfService")}
              </Link>
              <Link component={RouterLink} to="/privacy" color="text.primary" underline="hover">
                {t("Footer.privacyPolicy")}
              </Link>
              <Link component={RouterLink} to="/refunds" color="text.primary" underline="hover">
                {t("Footer.refundPolicy")}
              </Link>
            </Stack>

            <Stack spacing={1}>
              <Typography
                variant="overline"
                color="text.secondary"
                sx={{ fontWeight: 600, letterSpacing: "0.08em" }}
              >
                {t("Footer.company")}
              </Typography>
              <Link component={RouterLink} to="/contact" color="text.primary" underline="hover">
                {t("Footer.contact")}
              </Link>
              <Link
                href="mailto:support@career-forge.org"
                color="text.primary"
                underline="hover"
              >
                {t("Footer.supportEmail")}
              </Link>
            </Stack>
          </Stack>
        </Stack>

        <Divider sx={{ my: { xs: 3, md: 4 } }} />

        <Typography variant="caption" color="text.secondary">
          {t("Footer.copyright", { year: YEAR })}
        </Typography>
      </Container>
    </Box>
  );
}
